import type {BioIconProps} from '../common-types'

export function BrgIconStars({...attributes}: BioIconProps) {
  return (
    <svg width="53" height="95" viewBox="0 0 53 95" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M39.8452 27.9725C39.0711 26.7919 38.877 25.6112 38.2969 24.4306C38.1029 24.0371 38.2969 23.8398 38.491 23.6435C40.0393 21.8721 41.0074 19.9044 42.7488 18.134C43.3299 17.5432 43.7169 16.1663 41.0064 16.9534C40.0383 17.3469 38.2969 17.7404 35.7804 18.134C35.0063 18.3312 34.8123 18.134 34.6192 17.3469C33.8451 14.1986 32.1028 7.90193 31.1356 10.853C28.6191 18.7238 32.2968 17.5432 23.394 17.9367C20.1034 18.134 24.3622 22.0694 27.2648 23.6435C28.426 24.2343 27.8459 24.4306 27.0708 31.5143C27.0708 32.1052 26.6837 33.0885 27.4578 33.4821C28.232 33.8756 28.6191 33.0885 29.0061 32.4977C35.0063 26.0038 31.9097 26.7909 38.2959 30.53C41.1995 32.1042 40.8124 29.3494 39.8443 27.9715L39.8452 27.9725Z"
        fill="#F0C52B"
      />
      <path
        d="M28.2979 80.2604C23.6859 74.3535 24.0171 76.4459 28.4339 70.5417C30.4927 67.9102 24.8163 68.6172 21.6961 69.8302C20.2684 70.4705 15.5241 62.8088 14.3626 63.5168C14.0306 63.7192 13.7645 63.6514 15.0237 71.1443C15.6201 74.4516 -0.577932 73.7716 13.793 77.8595C14.855 78.1299 14.5902 78.0624 15.9148 85.2843C16.1799 86.4993 16.91 86.972 17.575 85.4201C20.5317 78.5704 20.83 79.0763 21.7256 79.4481C25.244 81.2042 30.5866 84.1415 28.2979 80.2604Z"
        fill="#F0C52B"
      />
      <path
        d="M22.0429 6.71756C26.1077 6.71756 25.9136 0.617188 22.2369 0.617188C18.3662 0.617188 17.9791 6.71756 22.0429 6.71756Z"
        fill="#F0C52B"
      />
      <path
        d="M4.50592 64.0145C7.16177 62.3956 4.77334 58.3453 2.11748 59.9642C-0.605009 61.8537 1.68365 65.7348 4.50592 64.0145Z"
        fill="#F0C52B"
      />
      <path
        d="M46.6211 56.8976C46.6211 53.7493 42.1692 53.9456 42.1692 56.8976C41.9752 59.8497 46.6211 60.0459 46.6211 56.8976Z"
        fill="#F0C52B"
      />
      <path
        d="M26.6001 93.4522C28.924 92.0356 26.6683 88.5921 24.51 89.9077C22.1861 91.3242 24.2763 94.8687 26.6001 93.4522Z"
        fill="#F0C52B"
      />
      <path
        d="M20.5878 47.3906C18.4584 47.3906 18.4584 50.7362 20.7818 50.7362C22.9112 50.7362 22.7172 47.3906 20.5878 47.3906Z"
        fill="#F0C52B"
      />
      <path
        d="M19.1358 26.3906C17.2004 26.3906 17.3935 29.5389 19.1358 29.5389C20.6841 29.3417 21.2652 26.3906 19.1358 26.3906Z"
        fill="#F0C52B"
      />
      <path
        d="M49.5249 28.7553C49.5249 30.5268 52.2344 30.723 52.2344 28.5581C52.0403 26.9839 49.5249 26.7866 49.5249 28.7553Z"
        fill="#F0C52B"
      />
    </svg>
  )
}
